import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce, createUnknownComponentVNode as _$cc } from 'intact-vue';
import { getRestProps } from '../utils';
import { Input } from '../input';
import { Icon } from '../icon';
import { makeStyles } from './styles';
import { Tooltip } from '../tooltip';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    children = _this$get.children,
    className = _this$get.className,
    editing = _this$get.editing,
    value = _this$get.value,
    validate = _this$get.validate,
    disabled = _this$get.disabled,
    tip = _this$get.tip,
    invalid = _this$get.invalid;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-editable"] = true, _classNameObj[k + "-editing"] = editing, _classNameObj[k + "-disabled"] = disabled, _classNameObj[k + "-invalid"] = invalid, _classNameObj[className] = className, _classNameObj[makeStyles(k)] = true, _classNameObj);
  return _$cv('div', _extends({}, getRestProps(this), {
    'className': _$cn(classNameObj)
  }), [_$ce(2, 'div', !editing ? children : _$cc(Input, {
    'size': 'mini',
    'defaultValue': value,
    'ev-blur': this.onBlur,
    'ev-keydown': this.onKeydown,
    'ref': this.inputRef,
    'frozenOnInput': true,
    'ev-$mounted': this.select,
    'autoWidth': true
  }, null, this.inputRef), 0, 'c-ellipsis'), !disabled && !editing ? _$cc(Tooltip, {
    'content': tip,
    'children': _$cc(Icon, {
      'className': _$cn(k + "-icon-edit " + k + "-editable-icon"),
      'ev-click': this.edit,
      'hoverable': true
    })
  }) : undefined]);
}
;